import React, { useState } from 'react'
import { OmDialog, OmInput } from '@owma/kit'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

interface SendAsAccount {
  id?: number | null
  name: string
  email: string
  isSelected?: boolean
  isDefault?: boolean
}

interface SendAsEmailInputProps {
  onClose: () => void
  onSave: (data: { name: string; email: string }) => void
  domain: string
  editSendAs?: SendAsAccount | null
}

const SendAsEmailInput: React.FC<SendAsEmailInputProps> = ({
  onClose,
  onSave,
  domain,
  editSendAs,
}) => {
  const { t } = useTranslation()
  const [name, setName] = useState(editSendAs?.name || '')
  const [email, setEmail] = useState(editSendAs?.email.split('@')[0] || '')

  const handleSave = (): void => {
    if (!name.trim() || !email.trim()) return

    onSave({
      name: name.trim(),
      email: email.trim(),
    })
    onClose()
  }

  return (
    <OmDialog
      title={t('settings.accountTabs.sendAsEditTitle')}
      open={true}
      closable={false}
      width={480}
      className={styles.modal}
      centered
    >
      <div className={styles.container}>
        <div className={styles.description}>{t('settings.accountTabs.sendAsEditDesc')}</div>
        <div className={styles.description2}>
          {'(' + t('settings.accountTabs.sendAsEditDesc2') + ')'}
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>{t('settings.accountTabs.sendAsEditName')}:</label>
          <div className={styles.nameInputWrapper}>
            <OmInput
              value={name}
              onChange={(value) => setName(value)}
              className={styles.nameInput}
            />
          </div>
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>{t('settings.accountTabs.sendAsEditEmail')}:</label>
          <div className={styles.rowInputWrapper}>
            <OmInput
              value={email}
              onChange={(value) => setEmail(value)}
              className={styles.emailInput}
            />
            <div className={styles.domainLabel}>@{domain}</div>
          </div>
        </div>
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            {t('common.button.cancel')}
          </button>
          <button
            className={`${styles.saveButton} ${
              !name.trim() || !email.trim() ? styles.disabled : ''
            }`}
            onClick={handleSave}
            disabled={!name.trim() || !email.trim()}
          >
            {t('common.button.add')}
          </button>
        </div>
      </div>
    </OmDialog>
  )
}

export default SendAsEmailInput
